
import { defineComponent } from "vue";

/***** Composables *****/
import useConfirmRoute from "@/composables/useConfirmRoute";
import { useFilteredJobs } from "@/store/composables";

export default defineComponent({
  name: "SubNav",
  setup() {
    const onJobResultsPage = useConfirmRoute("JobResults");
    const FILTERED_JOBS = useFilteredJobs();

    return {
      onJobResultsPage,
      FILTERED_JOBS,
    };
  },
});
